$(document).ready(function(){  
//   HOMEPAGE PRODUCT STORIES
  var newHomepageAdbox = '';
  var homePageLink = $('#homepage-stories-url').data('url');
  var homePageImg = $('#homapage-stories-img').data('imgsrc');
  var homePageTitle = $('#homepage-stories-title').data('abtitle');

  if( homePageLink != undefined ){
    newHomepageAdbox = '<div id="homepage-product-image">' +
      '<div class="home-readstory-image">' +	
      '<a href="'+ homePageLink +'">' + '<img src="'+ homePageImg +'">' + '</a>' +
      '<div class="home-readstory-title">' +
      '<a href="'+ homePageLink +'">' + homePageTitle + '</a>' +
      '</div>' +
      '<div class="home-readstory-subtitle">' +
      '<a href="'+ homePageLink +'">Story lesen</a>' +
      '</div>' +
      '</div>' +
      '</div>';
    $(newHomepageAdbox).insertAfter($('.home-product-first-wrap .product-first-grid:eq(2)'))

  } else {
    var newHomepageAdbox = '';
  };
  
//   HOMEPAGE PRODUCT CHANGE QTY, SIZE, ADDTOCART
  $('.homeproduct.plus').click(function(){
    var $this = $(this);
     $this.siblings('.input-text.qty').get(0).value++;
     
//     var qty = $this.siblings('.input-text.qty').val(),
//     	tags = $this.siblings('.input-text.qty').data('tags')
    
//     if(tags.indexOf('Online Exclusives') != -1){
      
//     }
  });
  
  $('.homeproduct.minus').click(function(){
    var $this = $(this);
    $this.siblings('.input-text.qty').get(0).value--;
  });
  

  
  $('.first-grid-addtocart-btn').click(function(e){
	var $this = $(this),
        $parent = $this.closest('.first-grid-buy-wrap'),
        $variantId = $parent.find('.first-grid-var-opt-size-select option:selected').data('mainid'),
    	$quantity = $parent.find('.input-text.qty').val(),
        $productData = "updates["+ $variantId+"]="+ $quantity+" ";
    
      if($this.hasClass('home-atc-btn-disabled')){
       e.preventDefault();
      }else{
        var $modal = $('.prod-modal'),
            $loader = $('.div-loader'),
            $message = $('.add-to-cart-message');

//         jQuery.post('/cart/update.js', 
//                     "updates["+$variantId+"]="+$quantity+"",
//                     setTimeout(function(){location.reload();},2000));
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: $quantity,
            id: $variantId
          },
          dataType: 'json',           
          success: function() {
            $modal.show();
            $loader.show();
            setTimeout(function() {
              $modal.hide();
              $loader.hide();
              $message.show();
            }, 1000)
            setTimeout(function(){
              $message.hide();
              location.reload();
            }, 2000)
          }
        });  
        
      }
    	
  })

  $('.bc-btn').hover(function(){
    var $this = $(this);
	$this.toggleClass('c-bg')
  });

  
  $('.first-grid-addtocart-btn').hover(function(){
    var $this = $(this);
    if($this.hasClass('home-atc-btn-disabled')){
      $this.toggleClass('no-hover')
    }else{
      $this.toggleClass('c-bg')
    }
  })
  
  $('.first-grid-var-opt-size-select').on('change',function(){
    var $this = $(this),
        $parent = $this.closest('.first-grid-buy-wrap'),
        stockQty1 = $("option:selected", this).attr('data-stockqty'),
        stockId = $("option:selected", this).data('mainid'),
        cartQty = $('#minicart-items').children('.mini-cart-products[data-incartid="'+stockId+'"]').data('incart'),
    	alltags = $("option:selected", this).data('ptags');
    cartQty = (isNaN(cartQty) ? 0 : cartQty);
    
    if(alltags.includes("Fast Moving")){
      var alltotal = stockQty1 - cartQty;
      if( alltotal <= 4 ){
        $parent.find('.first-grid-addtocart-btn').addClass('home-atc-btn-disabled');
      }else{
        $parent.find('.first-grid-addtocart-btn').removeClass('home-atc-btn-disabled');
      }
    }else{
      var alltotal = stockQty1 - cartQty;
      console.log(alltotal)
      if( alltotal <= 2 ){
        $parent.find('.first-grid-addtocart-btn').addClass('home-atc-btn-disabled');
      }else{
         $parent.find('.first-grid-addtocart-btn').removeClass('home-atc-btn-disabled');
      }
    }

  });
//   END OF HOMPAGE PRODUCT
  

  var homeWishBtn = $('.wishlist-home-btn')
  
  if(homeWishBtn.length > 0){
    function swymCallbackFn(){
      window._swat.fetch(function(r) {
        for (var i = 0; i < r.length; i++) {
          var aa = r[i].epi;

      $('.collection-card').find('.wishlist[data-id="'+aa+'"]').find('i').addClass('fas').removeClass('far');
        }
      });
    }
    if(!window.SwymCallbacks){
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }


  
  $('.wishlist-home-btn').click(function(e){
    e.preventDefault();

    var $this = $(this),
        heartIcon = $this.children().children(),
        wishId = $this.data('id'),
        dataUrl = $this.data('url'),
        wishUrl = "https://lush.com.ph" + dataUrl,
        wishCount = $this.data('count'),
        wishImg = $this.data('img'),
        wishPrice = $this.data('price'),
        wishMid = $this.data('mid');


        window._swat.addToWishList(
          {
            "epi": wishId,
            "du": wishUrl,
            "empi": wishMid,
            "iu" : wishImg,
            "pr": wishPrice,
            "stk": wishCount,
            "variants": ""
          },
          function(r) {
            heartIcon.removeClass('far');
            heartIcon.addClass('fas');
          }
        );
  });

});